import React from 'react'
import { Carousel } from 'antd'
import { LeftOutlined, RightOutlined } from "@ant-design/icons"

import styles from './index.module.scss'

export default class Swiper extends React.PureComponent {
  autoToNextTimer = null

  ref = React.createRef()
  onChange = () => {}
  handlePrev = () => {
    this.ref.current.prev()
  }
  handleNext = () => {
    this.ref.current.next()
  }

  componentDidMount (){
    // 自动播放
    this.autoToNextTimer = setInterval(() => {
      this.ref.current.next()
    }, 5000);
  }

  componentWillUnmount(){
    clearInterval(this.autoToNextTimer)
  }

  render () {
    const { list = [] } = this.props
    return (
      <div className={styles.wrap}>
        <Carousel
          afterChange={this.onChange}
          dots={false}
          ref={this.ref}
        >
          {list.map((item, index) =>
            <div key={index}>
              <img style={{ width: '100%' }} src={item.url} alt="" />
            </div>
          )}
        </Carousel>
        <div className={styles.prev} onClick={this.handlePrev}>
          <LeftOutlined></LeftOutlined>
        </div>
        <div className={styles.next} onClick={this.handleNext}>
          <RightOutlined></RightOutlined>
        </div>
      </div>
    )
  }
}
